/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */
import actions from '@/store/modules/orders/actions'
import Config from 'config'
import HttpProvider from '@/services/HttpProvider'
import Graphql from '@/services/Graphql'
import Bus from '@/services/Bus'
import { restWithCache } from '@/store/lib/search'
import { vwSetInfoOnOrder } from 'theme/services/graphQlquery/orderInfo'

actions.list = (ctx, filters) => {
  if (!ctx.rootGetters['userAdmin/isLogged']) {
    return Promise.reject(new Error('Admin not logged'))
  }
  let pagination = Math.ceil(ctx.state.pagination.start / ctx.state.pagination.size) + 1
  let limit = ctx.state.pagination.size
  let storeCode = ctx.rootGetters['userAdmin/getUserPlainStore']
  let orderBy = 'order_no'
  // let currentStoreCode = ctx.rootGetters['userAdmin/getCurrentStoreCode']
  let orderDirection = '0'
  let searchCriteria = `searchCriteria[filter_groups][0][filters][0][field]=c_storeId&
  searchCriteria[filter_groups][0][filters][0][value]=${storeCode}&
  searchCriteria[currentPage]=${pagination || '1'}&
  searchCriteria[pageSize]=${limit || '3'}`
  if (orderBy) {
    searchCriteria += `&searchCriteria[sortOrders][0][field]=${orderBy}&
    searchCriteria[sortOrders][0][direction]=${orderDirection === '1' ? 'asc' : 'desc'}`
  }
  if (filters) {
    let indexFilter = 0
    for (var key in filters) {
      indexFilter++
      searchCriteria += `&searchCriteria[filter_groups][${indexFilter}][filters][0][field]=${filters[key].field}&
      searchCriteria[filter_groups][${indexFilter}][filters][0][value]=${filters[key].value}&
      searchCriteria[filter_groups][${indexFilter}][filters][0][condition_type]=${filters[key].condition_type}`
    }
  }
  searchCriteria = searchCriteria.replace(/\s/g, '')
  let query = Config.API.search.orders.replace('{{storeViewCode}}', ctx.rootState.ui.storeViewCode).replace('searchCriteria', searchCriteria)
  return restWithCache({
    query,
    restPromise: HttpProvider.get(query, {
      headers: {
        'Authorization': `Bearer ${process.env.VUE_APP_MAGENTO_TOKEN}`
      }
    })
  })
    .then(res => {
      ctx.commit('setOrders', res.items)
      ctx.commit('setPagination', { ...ctx.state.pagination, total: res.total_count })
      return res
    })
}

actions.updateOrder = (ctx, { orderId, payload }) => {
  const query = Config.API.order.update
    .replace('{{storeViewCode}}', ctx.rootState.ui.storeViewCode)
    .replace('{{orderId}}', orderId)

  return HttpProvider.post(query, payload)
    .then((res) => {
      return res
    })
}

actions.getOrderById = (ctx, orderInfo) => {
  // API
  let query = Config.API.order.single
    .replace('{{storeViewCode}}', ctx.rootState.ui.storeViewCode)
    .replace('{{orderId}}', orderInfo.orderId)
  return HttpProvider.get(query)
    .then(res => {
      let order = res.data.items || []
      if (order && order.length > 0) {
        order = order[0]
        ctx.commit('setOrder', order)
      } else {
        ctx.commit('setOrder', {})
      }
      return order
    })
}

actions.getShipmentsByOrderId = (ctx, { orderId }) => {
  // API
  let query = Config.API.order.shipments
  query = query.replace('{{orderId}}', orderId)
  return Bus.get(query, {
    params: {
      storeViewCode: ctx.rootState.ui.storeViewCode
    }
  }).then(res => {
    return res.data
  })
}

actions.getOrderWithShipmentsInfo = (ctx, order) => {
  return ctx.dispatch('getOrderById', order)
    .then(res => {
      return Promise.all(res.items.map((order) => {
        return ctx.dispatch('getShipmentsByOrderId', {
          orderId: order.entity_id
        }).then(res => {
          if (res && res.total_count > 0 && res.items.length) {
            order['tracks'] = res.items.map(shipment => { return { ...shipment.tracks } }).flat()
            return order
          }
          return order
        })
      })).then(res => {
        ctx.commit('setOrder', res)
      })
    }).catch((error) => {
      throw error
    })
}

actions.setInfoOnOrder = (ctx, orderInfo) => {
  return Graphql.genericCall(
    {},
    ctx.rootState.user.token,
    ctx.rootState.ui.storeViewCode,
    null, // schema type
    {
      input: { ...orderInfo } // variables
    },
    false, // cache false
    {
      query: vwSetInfoOnOrder // options.query
    }
  )
    .then((res) => {
      return res
    })
}

export default {
  ...actions
}
